import React, { useEffect } from 'react';
import styled from 'styled-components';
import Carousel from 'nuka-carousel';

import Section from './global/section';
import Top from './top';

const StyledTestimonials = styled.div`
	section {
		text-align: center;

		.slider-container {
			width: 80%;
			margin: 2rem auto 4rem;
			.slide {
				.quote {
					background-color: ${(p) => p.theme.color.green};
					border-radius: 5rem;
					width: 5rem;
					margin: 0 auto 1rem;
					p {
						color: #fff;
						position: relative;
						top: 1rem;
						font-size: 5rem;
						line-height: 5rem;
						font-family: ${(p) => p.theme.fonts.heading};
					}
				}
				.text {
					width: 80%;
					margin: 0 auto;
					font-family: ${(p) => p.theme.fonts.serifBody};
				}
				.name {
					font-style: italic;
				}
			}
			.slider-control-centerright {
				right: -1rem !important;
				img {
					width: 1rem;
				}
			}
			.slider-control-centerleft {
				left: -1rem !important;
				img {
					width: 1rem;
				}
			}

			.slider-control-bottomcenter {
				bottom: -3rem !important;
				.paging-item {
					padding: 0 2px;
					.paging-dot {
						width: 10px !important;
						height: 10px !important;
						background-color: transparent !important;
						/* border: 1px solid ${(p) => p.theme.color.grey}; */
					}
					&.active .paging-dot {
						/* background-color: ${(p) => p.theme.color.grey} !important; */
					}
				}
			}

			@media all and (max-width: 450px) {
				width: calc(100% - 2rem);
			}
		}

		.logos {
			display: flex;
			.img-wrap {
				padding: 0 0.5rem;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			@media all and (max-width: 768px) {
				flex-wrap: wrap;
				justify-content: center;
				.img-wrap {
					width: 50%;
				}
			}
		}
	}
`;

export default () => {
	useEffect(() => {
		// hacky carousel fix
		setTimeout(() => window.dispatchEvent(new Event('resize')), 1000);
	});
	return (
		<StyledTestimonials>
			<Section bg={'light'}>
				<Top color="green">TESTIMONIALS</Top>
				<h2>From the Community</h2>
				<div className="slider-container">
					<Carousel
						renderCenterLeftControls={({ previousSlide }) => (
							<button aria-label="previous slide" onClick={previousSlide}>
								<img src="/img/chevron-left.svg" alt="chevron left" />
							</button>
						)}
						renderCenterRightControls={({ nextSlide }) => (
							<button aria-label="next slide" onClick={nextSlide}>
								<img src="/img/chevron-right.svg" alt="chevron right" />
							</button>
						)}
						wrapAround={true}
						autoplay={true}
						autoplayInterval={7000}
					>
						{slider.map((x, i) => (
							<div className="slide" key={i}>
								<div className="quote">
									<p>“</p>
								</div>
								<p className="text">{x.text}</p>
								<p className="name">{x.name}</p>
							</div>
						))}
					</Carousel>
				</div>
				{/* <div className="logos">
					{logos.map((x, i) => (
						<div className="img-wrap" key={i}>
							<img src={x.img} alt={x.alt} />
						</div>
					))}
				</div> */}
			</Section>
		</StyledTestimonials>
	);
};

const slider = [
	{
		text:
			'My children have been enrolled with Arcadia for several years. My son has taken Guitar and is enrolled in the Band Program, and my daughter is enrolled in Piano and Voice. Thank you Arcadia, you are great!',
		name: 'F. Priolo',
	},
	{
		text:
			'Great school with enthusiastic instructors. My child really enjoys lessons and looks forward to her lessons every week. We especially enjoy their annual Holiday concert! Thank you Arcadia!',
		name: 'Amalia Spiga',
	},
	{
		text:
			'We have been attending Arcadia for the past 5 years and not once have any of our three children complained about coming to their lessons. They have amazing instructors who genuinely love their work!',
		name: 'Michelle Bobechko',
	},
	{
		text:
			'What a great place! I enrolled in guitar lessons for myself and my 5yr old son, and so far we are having a great time! The lessons are tailored to each of our skill sets, and are taught by industry professionals.',
		name: 'Craig Eveson',
	},
	{
		text:
			'My daughter has been a student with Arcadia since 2011. We have experienced such a welcoming feeling upon entering their doors. We look back with pride on her recorded performances from annual concerts.',
		name: 'Rose Scaccia',
	},
	{
		text:
			'Fantastic music program! Talented instructors and staff. They really love music and my children have learned so much. I highly recommend Arcadia for beginner musicians and experienced musicians.',
		name: 'Ru Zab',
	},
];
// const logos = [
// 	{
// 		img: '/img/Image 1.png',
// 		alt: 'york university logo',
// 	},
// 	{
// 		img: '/img/Image 2.png',
// 		alt: 'vaughan logo',
// 	},
// 	{
// 		img: '/img/Image 3.png',
// 		alt: 'cedar centre logo',
// 	},
// 	{
// 		img: '/img/Image 4.png',
// 		alt: 'music monday logo',
// 	},
// 	{
// 		img: '/img/Image 5.png',
// 		alt: 'mackenzie health logo',
// 	},
// 	{
// 		img: '/img/Image 6.png',
// 		alt: 'vaughan film festival logo',
// 	},
// ];
